const concurrent_device_limit = {
    title: 'จำกัดอุปกรณ์พร้อมกัน',
    enable: 'เปิดใช้งานการจำกัดอุปกรณ์พร้อมกัน',
    enable_description: 'เมื่อเปิดใช้งาน Logto จะบังคับใช้การอนุญาตสูงสุดต่อผู้ใช้ต่อแอปนี้',
    field: 'จำกัดอุปกรณ์พร้อมกันต่อแอป',
    field_description: 'จำกัดจำนวนอุปกรณ์ที่ผู้ใช้สามารถลงชื่อเข้าใช้พร้อมกัน Logto จะบังคับใช้โดยจำกัดการอนุญาตที่ใช้งานอยู่และเพิกถอนการอนุญาตที่เก่าที่สุดโดยอัตโนมัติเมื่อเกินขีดจำกัด',
    field_placeholder: 'เว้นว่างไว้เพื่อไม่จำกัด',
    should_be_greater_than_zero: 'ควรมากกว่า 0',
};
export default Object.freeze(concurrent_device_limit);
